import { FormInstance } from "antd/es/form";
import moment from "moment";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IProjeEdit_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IProjeEdit_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  PROJE_GETIR: any[];
  PROJE_GETIR_dummy: any[];
  GET_PROJE_KATEGORILERI: any[];
  GET_PROJE_KATEGORILERI_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  GET_PROJE_TURU: any[];
  GET_PROJE_TURU_dummy: any[];
  GET_PROJE_TIPI: any[];
  GET_PROJE_TIPI_dummy: any[];
  GET_PROJEYONETICI_USERS: any[];
  GET_PROJEYONETICI_USERS_dummy: any[];
  GetUserByUsername: any[];
  GetUserByUsername_dummy: any[];
  GetProjeAsamalari: any[];
  GetProjeAsamalari_dummy: any[];
  AktifSirketGetir: any[];
  AktifSirketGetir_dummy: any[];
  NETSIS_PROJE_OLUSTUR: any[];
  NETSIS_PROJE_OLUSTUR_dummy: any[];
  YeniGenelProjeOlustur: any[];
  YeniGenelProjeOlustur_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
  isComp268057Visible: "visible" | "hidden";
  isComp327156Visible: "visible" | "hidden";
  isComp201276Visible: "visible" | "hidden";
  isComp665925Visible: "visible" | "hidden";
  isComp626249Visible: "visible" | "hidden";
  isComp228157Visible: "visible" | "hidden";
  isComp857613Enabled: "enabled" | "disabled";
}

export class ProjeEdit_ScreenBase extends React.PureComponent<
  IProjeEdit_ScreenProps,
  any
> {
  projeedit_857613_value_kuikaAutoCompleteRef: React.RefObject<any>;
  projeedit_403147_value_kuikaAutoCompleteRef: React.RefObject<any>;
  projeedit_65470_value_kuikaAutoCompleteRef: React.RefObject<any>;
  projeedit_502939_value_kuikaDateRef: React.RefObject<any>;
  projeedit_550625_value_kuikaDateRef: React.RefObject<any>;
  projeedit_483299_value_kuikaSelectBoxRef: React.RefObject<any>;
  projeedit_214215_value_kuikaTableRef: React.RefObject<any>;
  projeedit_66343_value_kuikaDateRef: React.RefObject<any>;
  projeedit_371229_value_kuikaDateRef: React.RefObject<any>;
  ml = [
    {
      Id: "08e1cb20-24ad-e190-d46b-beded98dd4ae",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "4106607f-9ae3-47ff-8d8a-3ced44ab92c6",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "9a3823f4-ef1e-4136-8756-ebdb4feadb4b",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 301252, PropertyName: "value", Value: "Proje Düzenle" },
        { Id: 713759, PropertyName: "value", Value: "Proje Adı *" },
        { Id: 480528, PropertyName: "placeholder", Value: "Proje adı girin" },
        { Id: 988678, PropertyName: "value", Value: "Proje Kategorisi *" },
        { Id: 857613, PropertyName: "placeholder", Value: "Kategori Seçin..." },
        { Id: 349300, PropertyName: "value", Value: "Proje Tipi *" },
        {
          Id: 403147,
          PropertyName: "placeholder",
          Value: "Proje Tipi Seçin...",
        },
        { Id: 222673, PropertyName: "value", Value: "Proje Türü *" },
        {
          Id: 65470,
          PropertyName: "placeholder",
          Value: "Proje Türü Seçin...",
        },
        { Id: 290269, PropertyName: "value", Value: "Güç (kWp) *" },
        { Id: 606391, PropertyName: "value", Value: "Güç (kW) *" },
        { Id: 61112, PropertyName: "value", Value: "Kapasite (kW) *" },
        { Id: 830247, PropertyName: "value", Value: "Alan (m²) *" },
        { Id: 903434, PropertyName: "value", Value: "Müşteri Adı *" },
        { Id: 67994, PropertyName: "placeholder", Value: "Müşteri Adı" },
        { Id: 320806, PropertyName: "value", Value: "İletişim Kişisi" },
        { Id: 572576, PropertyName: "placeholder", Value: "Yetkili kişi" },
        { Id: 983516, PropertyName: "value", Value: "Telefon" },
        { Id: 205928, PropertyName: "placeholder", Value: "Telefon numarası" },
        { Id: 670479, PropertyName: "value", Value: "E-posta" },
        { Id: 997091, PropertyName: "placeholder", Value: "E-posta adresi" },
        { Id: 908253, PropertyName: "value", Value: "Başlangıç Tarihi" },
        { Id: 502939, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 825970, PropertyName: "value", Value: "Tahmini Bitiş" },
        { Id: 550625, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 704278, PropertyName: "value", Value: "Bütçe (₺)" },
        { Id: 989743, PropertyName: "placeholder", Value: "Bütçe girin" },
        { Id: 417222, PropertyName: "value", Value: "Proje Yöneticisi" },
        {
          Id: 483299,
          PropertyName: "placeholder",
          Value: "Proje Yöneticisi Seçin...",
        },
        { Id: 632061, PropertyName: "value", Value: "Adres" },
        {
          Id: 403783,
          PropertyName: "placeholder",
          Value: "Adres bilgisi girin",
        },
        { Id: 384372, PropertyName: "value", Value: "Proje Açıklaması" },
        {
          Id: 35817,
          PropertyName: "placeholder",
          Value: "Proje detayları ve notlar...",
        },
        { Id: 896270, PropertyName: "label", Value: "İptal" },
        { Id: 154680, PropertyName: "label", Value: "Temizle" },
        { Id: 163762, PropertyName: "label", Value: "Kaydet" },
        { Id: 351112, PropertyName: "value", Value: "Proje Aşamaları" },
        { Id: 685315, PropertyName: "title", Value: "Title" },
        { Id: 513161, PropertyName: "value", Value: "[datafield:asamaadi]" },
        { Id: 740034, PropertyName: "value", Value: "Ağırlık: %" },
        { Id: 333321, PropertyName: "value", Value: "[datafield:yuzde]" },
        { Id: 66343, PropertyName: "placeholder", Value: "gg.aa.yyyy" },
        { Id: 371229, PropertyName: "placeholder", Value: "gg.aa.yyyy" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.projeedit_480528_value_kuikaTextInputRef = React.createRef();
    this.projeedit_857613_value_kuikaAutoCompleteRef = React.createRef();
    this.projeedit_403147_value_kuikaAutoCompleteRef = React.createRef();
    this.projeedit_65470_value_kuikaAutoCompleteRef = React.createRef();
    this.projeedit_67994_value_kuikaTextInputRef = React.createRef();
    this.projeedit_572576_value_kuikaTextInputRef = React.createRef();
    this.projeedit_205928_value_kuikaTextInputRef = React.createRef();
    this.projeedit_502939_value_kuikaDateRef = React.createRef();
    this.projeedit_550625_value_kuikaDateRef = React.createRef();
    this.projeedit_483299_value_kuikaSelectBoxRef = React.createRef();
    this.projeedit_214215_value_kuikaTableRef = React.createRef();
    this.projeedit_66343_value_kuikaDateRef = React.createRef();
    this.projeedit_371229_value_kuikaDateRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      PROJE_GETIR: [],
      GET_PROJE_KATEGORILERI: [],
      SetValueOf: "",
      GET_PROJE_TURU: [],
      GET_PROJE_TIPI: [],
      GET_PROJEYONETICI_USERS: [],
      GetUserByUsername: [],
      GetProjeAsamalari: [],
      AktifSirketGetir: [],
      NETSIS_PROJE_OLUSTUR: [],
      YeniGenelProjeOlustur: [],
      Notify: false,
      isComp268057Visible: "hidden",
      isComp327156Visible: "hidden",
      isComp201276Visible: "hidden",
      isComp665925Visible: "hidden",
      isComp626249Visible: "hidden",
      isComp228157Visible: "hidden",
      isComp857613Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("projeedit", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.ProjeEditPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("projeedit", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("projeedit", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.ProjeEditPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      projeedit_480528_value:
        this.state.PROJE_GETIR?.at?.(0)?.projeAdi ?? undefined,
      projeedit_857613_value:
        this.state.PROJE_GETIR?.at?.(0)?.kategoriKodu ?? undefined,
      projeedit_403147_value:
        this.state.PROJE_GETIR?.at?.(0)?.tipKodu ?? undefined,
      projeedit_65470_value:
        this.state.PROJE_GETIR?.at?.(0)?.turKodu ?? undefined,
      projeedit_150733_value:
        this.state.PROJE_GETIR?.at?.(0)?.gucKwp ?? undefined,
      projeedit_340144_value:
        this.state.PROJE_GETIR?.at?.(0)?.gucKw ?? undefined,
      projeedit_854212_value:
        this.state.PROJE_GETIR?.at?.(0)?.kapasiteKw ?? undefined,
      projeedit_821409_value: ReactSystemFunctions.value(
        this,
        "projeedit_821409_value",
        "value"
      ),
      projeedit_67994_value:
        this.state.PROJE_GETIR?.at?.(0)?.musteriAdi ?? undefined,
      projeedit_572576_value:
        this.state.PROJE_GETIR?.at?.(0)?.iletisimKisi ?? undefined,
      projeedit_205928_value:
        this.state.PROJE_GETIR?.at?.(0)?.telefon ?? undefined,
      projeedit_997091_value:
        this.state.PROJE_GETIR?.at?.(0)?.eposta ?? undefined,
      projeedit_502939_value:
        this.state.PROJE_GETIR?.at?.(0)?.baslangicTarihi ?? undefined,
      projeedit_550625_value:
        this.state.PROJE_GETIR?.at?.(0)?.tahminiBitis ?? undefined,
      projeedit_989743_value:
        this.state.PROJE_GETIR?.at?.(0)?.butce ?? undefined,
      projeedit_483299_value:
        this.state.PROJE_GETIR?.at?.(0)?.projeYoneticisiId ?? undefined,
      projeedit_403783_value:
        this.state.PROJE_GETIR?.at?.(0)?.adres ?? undefined,
      projeedit_35817_value:
        this.state.PROJE_GETIR?.at?.(0)?.aciklama ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  ProjeEditPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProjeEdit/ProjeEditPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.PROJE_GETIR = result?.data.projE_GETIR;
    formVars.projeedit_480528_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].projeAdi
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].projeAdi
        : null
    );
    formVars.projeedit_857613_value =
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].kategoriKodu
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].kategoriKodu
        : null;
    formVars.projeedit_857613_options = stateVars.GET_PROJE_KATEGORILERI;
    formVars.projeedit_403147_value =
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].tipKodu
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].tipKodu
        : null;
    formVars.projeedit_65470_value =
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].turKodu
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].turKodu
        : null;
    formVars.projeedit_150733_value = ReactSystemFunctions.value(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].gucKwp
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].gucKwp
        : null
    );
    formVars.projeedit_340144_value = ReactSystemFunctions.value(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].gucKw
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].gucKw
        : null
    );
    formVars.projeedit_854212_value = ReactSystemFunctions.value(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].kapasiteKw
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].kapasiteKw
        : null
    );
    formVars.projeedit_67994_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].musteriAdi
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].musteriAdi
        : null
    );
    formVars.projeedit_572576_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].iletisimKisi
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].iletisimKisi
        : null
    );
    formVars.projeedit_205928_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].telefon
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].telefon
        : null
    );
    formVars.projeedit_997091_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].eposta
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].eposta
        : null
    );
    formVars.projeedit_502939_value = ReactSystemFunctions.value(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].baslangicTarihi
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].baslangicTarihi
        : null
    );
    formVars.projeedit_550625_value = ReactSystemFunctions.value(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].tahminiBitis
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].tahminiBitis
        : null
    );
    formVars.projeedit_550625_disablebeforedate = moment().format(
      "YYYY-MM-DDTHH:mm:ss"
    );
    formVars.projeedit_989743_value = ReactSystemFunctions.value(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].butce
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].butce
        : null
    );
    formVars.projeedit_483299_value =
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].projeYoneticisiId
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].projeYoneticisiId
        : null;
    formVars.projeedit_403783_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].adres
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].adres
        : null
    );
    formVars.projeedit_35817_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].aciklama
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].aciklama
        : null
    );
    stateVars.GET_PROJE_KATEGORILERI = result?.data.geT_PROJE_KATEGORILERI;

    formVars.projeedit_857613_value =
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].kategoriKodu
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].kategoriKodu
        : null;
    formVars.projeedit_857613_options = stateVars.GET_PROJE_KATEGORILERI;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjeEditPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjeEditPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "projeedit_857613_value",
        "string"
      ),
      this.props.screenInputs.ProjeCategory ??
        this.props.screenInputs.projecategory,
      null,
      "KategoriKodu"
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjeEditPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ProjeEditPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProjeEdit/ProjeEditPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJE_TURU = result?.data.geT_PROJE_TURU;

    formVars.projeedit_65470_options = stateVars.GET_PROJE_TURU;
    stateVars.GET_PROJE_TIPI = result?.data.geT_PROJE_TIPI;

    formVars.projeedit_403147_options = stateVars.GET_PROJE_TIPI;
    stateVars.GET_PROJEYONETICI_USERS = result?.data.geT_PROJEYONETICI_USERS;

    formVars.projeedit_483299_options = stateVars.GET_PROJEYONETICI_USERS;
    stateVars.GetUserByUsername = result?.data.getUserByUsername;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjeEditPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjeEditPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.projeedit_480528_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].projeAdi
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].projeAdi
        : null
    );

    formVars.projeedit_857613_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].kategoriKodu
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].kategoriKodu
        : null
    );

    stateVars.dataSource_857613 =
      stateVars.GET_PROJE_KATEGORILERI ?? this.state.GET_PROJE_KATEGORILERI;
    stateVars.dataSource_857613 =
      stateVars.GET_PROJE_KATEGORILERI ?? this.state.GET_PROJE_KATEGORILERI;
    stateVars.isComp857613Enabled =
      ReactSystemFunctions.isEmpty(
        this.props.screenInputs.ProjeCategory ??
          this.props.screenInputs.projecategory,
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp268057Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_857613_value",
            "value",
            "GET_PROJE_KATEGORILERI",
            "kategoriKodu",
            "kategoriKodu"
          )
        ),
        ReactSystemFunctions.convertToTypeByName("CATI_GES", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.projeedit_403147_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].tipKodu
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].tipKodu
        : null
    );

    stateVars.dataSource_403147 =
      stateVars.GET_PROJE_TIPI ?? this.state.GET_PROJE_TIPI;
    stateVars.dataSource_403147 =
      stateVars.GET_PROJE_TIPI ?? this.state.GET_PROJE_TIPI;
    stateVars.isComp327156Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_857613_value",
            "value",
            "GET_PROJE_KATEGORILERI",
            "kategoriKodu",
            "kategoriKodu"
          )
        ),
        ReactSystemFunctions.convertToTypeByName("CATI_GES", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.projeedit_65470_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].turKodu
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].turKodu
        : null
    );

    stateVars.dataSource_65470 =
      stateVars.GET_PROJE_TURU ?? this.state.GET_PROJE_TURU;
    stateVars.dataSource_65470 =
      stateVars.GET_PROJE_TURU ?? this.state.GET_PROJE_TURU;
    stateVars.isComp201276Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_857613_value",
            "value",
            "GET_PROJE_KATEGORILERI",
            "kategoriKodu",
            "kategoriKodu"
          )
        ),
        ReactSystemFunctions.convertToTypeByName("CATI_GES", "string")
      ) ||
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.toString(
            this,
            ReactSystemFunctions.value(
              this,
              "projeedit_857613_value",
              "value",
              "GET_PROJE_KATEGORILERI",
              "kategoriKodu",
              "kategoriKodu"
            )
          ),
          ReactSystemFunctions.convertToTypeByName("ARAZI_GES", "string")
        ) ||
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.toString(
            this,
            ReactSystemFunctions.value(
              this,
              "projeedit_857613_value",
              "value",
              "GET_PROJE_KATEGORILERI",
              "kategoriKodu",
              "kategoriKodu"
            )
          ),
          ReactSystemFunctions.convertToTypeByName("SULAMA_GES", "string")
        )) === true
        ? "visible"
        : "hidden";
    formVars.projeedit_150733_value = ReactSystemFunctions.value(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].gucKwp
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].gucKwp
        : null
    );

    stateVars.isComp665925Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_857613_value",
            "value",
            "GET_PROJE_KATEGORILERI",
            "kategoriKodu",
            "kategoriKodu"
          )
        ),
        ReactSystemFunctions.convertToTypeByName("SARJ_ISTASYONU", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.projeedit_340144_value = ReactSystemFunctions.value(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].gucKw
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].gucKw
        : null
    );

    stateVars.isComp626249Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_857613_value",
            "value",
            "GET_PROJE_KATEGORILERI",
            "kategoriKodu",
            "kategoriKodu"
          )
        ),
        ReactSystemFunctions.convertToTypeByName("ISI_POMPASI", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.projeedit_854212_value = ReactSystemFunctions.value(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].kapasiteKw
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].kapasiteKw
        : null
    );

    stateVars.isComp228157Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_857613_value",
            "value",
            "GET_PROJE_KATEGORILERI",
            "kategoriKodu",
            "kategoriKodu"
          )
        ),
        ReactSystemFunctions.convertToTypeByName("AKILLI_EV", "string")
      ) === true
        ? "visible"
        : "hidden";

    formVars.projeedit_67994_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].musteriAdi
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].musteriAdi
        : null
    );

    formVars.projeedit_572576_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].iletisimKisi
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].iletisimKisi
        : null
    );

    formVars.projeedit_205928_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].telefon
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].telefon
        : null
    );

    formVars.projeedit_997091_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].eposta
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].eposta
        : null
    );

    formVars.projeedit_502939_value = ReactSystemFunctions.value(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].baslangicTarihi
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].baslangicTarihi
        : null
    );

    formVars.projeedit_550625_value = ReactSystemFunctions.value(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].tahminiBitis
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].tahminiBitis
        : null
    );

    formVars.projeedit_989743_value = ReactSystemFunctions.value(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].butce
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].butce
        : null
    );

    formVars.projeedit_483299_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].projeYoneticisiId
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].projeYoneticisiId
        : null
    );

    stateVars.dataSource_483299 =
      stateVars.GET_PROJEYONETICI_USERS ?? this.state.GET_PROJEYONETICI_USERS;
    stateVars.dataSource_483299 =
      stateVars.GET_PROJEYONETICI_USERS ?? this.state.GET_PROJEYONETICI_USERS;
    formVars.projeedit_403783_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].adres
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].adres
        : null
    );

    formVars.projeedit_35817_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_GETIR !== undefined
        ? stateVars.PROJE_GETIR?.length > 0
          ? stateVars.PROJE_GETIR[0].aciklama
          : null
        : this.state.PROJE_GETIR?.length > 0
        ? this.state.PROJE_GETIR[0].aciklama
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  ProjeEditComponent_925037_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjeEditComponent_857613_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "projeedit_857613_value",
          "value",
          "GET_PROJE_KATEGORILERI",
          "kategoriKodu",
          ""
        ),
        null
      ),
      message: "Bu alan boş olamaz !",
      formName: "projeedit_857613_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KategoriKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_857613_value",
            "value",
            "GET_PROJE_KATEGORILERI",
            "kategoriKodu",
            "kategoriKodu"
          )
        ),
        "string"
      ),
      TipKodu_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProjeEdit/ProjeEditComponent_857613_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetProjeAsamalari = result?.data.getProjeAsamalari;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjeEditComponent_857613_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjeEditComponent_857613_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp268057Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_857613_value",
            "value",
            "GET_PROJE_KATEGORILERI",
            "kategoriKodu",
            "kategoriKodu"
          )
        ),
        ReactSystemFunctions.convertToTypeByName("CATI_GES", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp327156Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_857613_value",
            "value",
            "GET_PROJE_KATEGORILERI",
            "kategoriKodu",
            "kategoriKodu"
          )
        ),
        ReactSystemFunctions.convertToTypeByName("CATI_GES", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp201276Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_857613_value",
            "value",
            "GET_PROJE_KATEGORILERI",
            "kategoriKodu",
            "kategoriKodu"
          )
        ),
        ReactSystemFunctions.convertToTypeByName("CATI_GES", "string")
      ) ||
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.toString(
            this,
            ReactSystemFunctions.value(
              this,
              "projeedit_857613_value",
              "value",
              "GET_PROJE_KATEGORILERI",
              "kategoriKodu",
              "kategoriKodu"
            )
          ),
          ReactSystemFunctions.convertToTypeByName("ARAZI_GES", "string")
        ) ||
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.toString(
            this,
            ReactSystemFunctions.value(
              this,
              "projeedit_857613_value",
              "value",
              "GET_PROJE_KATEGORILERI",
              "kategoriKodu",
              "kategoriKodu"
            )
          ),
          ReactSystemFunctions.convertToTypeByName("SULAMA_GES", "string")
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp201276Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_857613_value",
            "value",
            "GET_PROJE_KATEGORILERI",
            "kategoriKodu",
            "kategoriKodu"
          )
        ),
        ReactSystemFunctions.convertToTypeByName("CATI_GES", "string")
      ) ||
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.toString(
            this,
            ReactSystemFunctions.value(
              this,
              "projeedit_857613_value",
              "value",
              "GET_PROJE_KATEGORILERI",
              "kategoriKodu",
              "kategoriKodu"
            )
          ),
          ReactSystemFunctions.convertToTypeByName("ARAZI_GES", "string")
        ) ||
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.toString(
            this,
            ReactSystemFunctions.value(
              this,
              "projeedit_857613_value",
              "value",
              "GET_PROJE_KATEGORILERI",
              "kategoriKodu",
              "kategoriKodu"
            )
          ),
          ReactSystemFunctions.convertToTypeByName("SULAMA_GES", "string")
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp201276Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_857613_value",
            "value",
            "GET_PROJE_KATEGORILERI",
            "kategoriKodu",
            "kategoriKodu"
          )
        ),
        ReactSystemFunctions.convertToTypeByName("CATI_GES", "string")
      ) ||
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.toString(
            this,
            ReactSystemFunctions.value(
              this,
              "projeedit_857613_value",
              "value",
              "GET_PROJE_KATEGORILERI",
              "kategoriKodu",
              "kategoriKodu"
            )
          ),
          ReactSystemFunctions.convertToTypeByName("ARAZI_GES", "string")
        ) ||
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.toString(
            this,
            ReactSystemFunctions.value(
              this,
              "projeedit_857613_value",
              "value",
              "GET_PROJE_KATEGORILERI",
              "kategoriKodu",
              "kategoriKodu"
            )
          ),
          ReactSystemFunctions.convertToTypeByName("SULAMA_GES", "string")
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp665925Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_857613_value",
            "value",
            "GET_PROJE_KATEGORILERI",
            "kategoriKodu",
            "kategoriKodu"
          )
        ),
        ReactSystemFunctions.convertToTypeByName("SARJ_ISTASYONU", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp626249Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_857613_value",
            "value",
            "GET_PROJE_KATEGORILERI",
            "kategoriKodu",
            "kategoriKodu"
          )
        ),
        ReactSystemFunctions.convertToTypeByName("ISI_POMPASI", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp228157Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_857613_value",
            "value",
            "GET_PROJE_KATEGORILERI",
            "kategoriKodu",
            "kategoriKodu"
          )
        ),
        ReactSystemFunctions.convertToTypeByName("AKILLI_EV", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_214215 =
      stateVars.GetProjeAsamalari ?? this.state.GetProjeAsamalari;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjeEditComponent_896270_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjeEditComponent_154680_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "projeedit_205928_value",
        "string"
      ),
      null,
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjeEditComponent_163762_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "projeedit_480528_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Bu alan boş olamaz !",
      formName: "projeedit_480528_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "projeedit_857613_value",
          "value",
          "GET_PROJE_KATEGORILERI",
          "kategoriKodu",
          ""
        ),
        null
      ),
      message: "Bu alan boş olamaz !",
      formName: "projeedit_857613_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "projeedit_857613_value",
          "value",
          "GET_PROJE_KATEGORILERI",
          "kategoriKodu",
          ""
        ),
        null
      ),
      message: "Bu alan boş olamaz !",
      formName: "projeedit_403147_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "projeedit_857613_value",
          "value",
          "GET_PROJE_KATEGORILERI",
          "kategoriKodu",
          ""
        ),
        null
      ),
      message: "Bu alan boş olamaz !",
      formName: "projeedit_65470_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isValidEmail(
        ReactSystemFunctions.value(
          this,
          "projeedit_997091_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Geçerli bir mail adresi giriniz.",
      formName: "projeedit_997091_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "projeedit_483299_value",
          "value",
          "GET_PROJEYONETICI_USERS",
          "kuserid",
          ""
        ),
        null
      ),
      message: "Bu alan boş olamaz !",
      formName: "projeedit_483299_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "projeedit_502939_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Bu alan boş olamaz !",
      formName: "projeedit_502939_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "projeedit_550625_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Bu alan boş olamaz !",
      formName: "projeedit_550625_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "projeedit_989743_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Bu alan boş olamaz !",
      formName: "projeedit_989743_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DbName_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.AktifSirketGetir !== undefined
            ? stateVars.AktifSirketGetir?.length > 0
              ? stateVars.AktifSirketGetir[0].sirket
              : null
            : this.state.AktifSirketGetir?.length > 0
            ? this.state.AktifSirketGetir[0].sirket
            : null
        ),
        "string"
      ),
      ProjeAdi_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_480528_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      KullaniciID_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
      KategoriKodu_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_857613_value",
            "value",
            "GET_PROJE_KATEGORILERI",
            "kategoriKodu",
            "kategoriKodu"
          )
        ),
        "string"
      ),
      TipKodu_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_403147_value",
            "value",
            "GET_PROJE_TIPI",
            "tipKodu",
            "tipKodu"
          )
        ),
        "string"
      ),
      TurKodu_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_65470_value",
            "value",
            "GET_PROJE_TURU",
            "turKodu",
            "turKodu"
          )
        ),
        "string"
      ),
      ProjeAdi_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_480528_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      MusteriAdi_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_67994_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      IletisimKisi_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_572576_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Telefon_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_205928_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Eposta_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_997091_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ProjeYoneticisiId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_483299_value",
            "value",
            "GET_PROJEYONETICI_USERS",
            "kuserid",
            "kuserid"
          )
        ),
        "string"
      ),
      SorumluKullaniciId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_483299_value",
            "value",
            "GET_PROJEYONETICI_USERS",
            "kuserid",
            "kuserid"
          )
        ),
        "string"
      ),
      BaslangicTarihi_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_502939_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      TahminiBitis_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_550625_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      Butce_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_989743_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      DovizTipi_2: ReactSystemFunctions.convertToTypeByName(0, "number"),
      Adres_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_403783_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Aciklama_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_35817_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      NetsisProjKodu_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.NETSIS_PROJE_OLUSTUR !== undefined
            ? stateVars.NETSIS_PROJE_OLUSTUR?.length > 0
              ? stateVars.NETSIS_PROJE_OLUSTUR[0].projeKodu
              : null
            : this.state.NETSIS_PROJE_OLUSTUR?.length > 0
            ? this.state.NETSIS_PROJE_OLUSTUR[0].projeKodu
            : null
        ),
        "string"
      ),
      GucKwp_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_150733_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      GucKw_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_340144_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      KapasiteKw_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_854212_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      AlanM2_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeedit_821409_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      OlusturanId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProjeEdit/ProjeEditComponent_163762_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.AktifSirketGetir = result?.data.aktifSirketGetir;
    stateVars.NETSIS_PROJE_OLUSTUR = result?.data.netsiS_PROJE_OLUSTUR;
    stateVars.YeniGenelProjeOlustur = result?.data.yeniGenelProjeOlustur;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjeEditComponent_163762_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjeEditComponent_163762_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "e97d0c6f_3c3e_f837_d0d0_cb8337205e80_notify",
        this.defaultML,
        "Yeni Proje Başarıyla Oluşturuldu !"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjeEditComponent_821409_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.ProjeEditPageInit();
    }
  }
}
